import { TRIGGER_FETCH_CARD_DETAILS_API, TRIGGER_FETCH_CARD_DETAILS_API_SUCCESS } from 'redux/actionTypes';

export function triggerFetchCardDetailsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_CARD_DETAILS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchCardDetailsApiCallSuccess(data) {
	return {
		type: TRIGGER_FETCH_CARD_DETAILS_API_SUCCESS,
		data,
	};
}
